import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PortfolioPpc"},[_c('h5',{staticClass:"Title"},[_vm._v(" PPC (Paymet Guarantee) ")]),_c('div',{staticClass:"Input"},[_c(VTextField,{attrs:{"label":"Days"}})],1),_c('div',{staticClass:"Input"},[_c(VTextField,{attrs:{"label":"Deadline for Payment "}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }